export const redirectURLDefault = process.env.REDIRECT_URL_DEFAULT || 'https://wortise.com';
